import type { Appointment } from '@/models/appointment/Appointment.ts';

import { cn } from '@/utils/styleUtils.ts';

export type PillColor = 'violet' | 'blue' | 'red' | 'green';
type PillVariant = 'filled' | 'light';

export const getCollectionPillColor = (appointment: Pick<Appointment, 'chain_configuration_id'>): PillColor =>
    appointment.chain_configuration_id ? 'blue' : 'violet';

const colorStyles: Record<PillVariant, Record<PillColor, string>> = {
    filled: {
        violet: 'bg-violet-500 text-white',
        blue: 'bg-blue-500 text-white',
        red: 'bg-red-500 text-white',
        green: 'bg-green-500 text-white',
    },
    light: {
        blue: 'bg-blue-100 text-blue-700',
        red: 'bg-red-100 text-red-700',
        green: 'bg-green-100 text-green-700',
        violet: 'bg-violet-100 text-violet-700',
    },
};

const sizeStyles: Record<string, string> = {
    small: 'text-[10px] px-1 py-0.25',
    normal: 'text-xs px-1.5 py-0.5',
};

interface Props {
    text: string;
    color: PillColor;
    variant?: PillVariant;
    size?: 'small' | 'normal';
}

export const AppointmentPill = ({ text, color, variant = 'light', size = 'normal' }: Props) => {
    return (
        <span
            className={cn(
                'inline-flex shrink-0 items-center rounded-md font-medium',
                colorStyles[variant][color],
                sizeStyles[size]
            )}
        >
            {text}
        </span>
    );
};
